const _UNLOCKCHECK = 5000;
let _galaxyStars = [];
let _vortex = 0;
let _collapse = false;
let _galaxyRunning = false;

Vue.component('openPack', {
  template: templates.openPack,
  data() {
    return {
      model: {
        ctx: null,
        canvas: null,
        id: null,
        twitchId: null,
        twitchDisplayName: null,
        currentUserId: null,
        settings: {},
        card: [{
            id: '1',
            name: ''
        }],
        userCards: null,
        packLoaded: false,
        scrollInterval: null,
        abilities: null,
        boneCards: {},
        ascensionCard: {},
        deltaCards: {},
        audio: {},
        index: 0,
        pack: 'pack-cover',
        cards: {},
        packs: {},
        frameDrops: [],
        backgroundDrops: [],
        obsOverlay: {
          visible: false,
          toggleState: 'off', // 'on' or 'off' - identifier for toggle state
          mode: 'modal', // 'modal', 'side', 'bottom'
          displayMode: 'broadcast', // 'broadcast' or 'extension' - streamer's choice to show on OBS or extension only
          recentPacks: [],
          allPacks: [], // Store raw data before filtering
          connected: false,
          viewerPreference: 'all', // 'all', 'mine', 'others' - viewer's preference (DEPRECATED - kept for compatibility)
          streamerConfig: { // Streamer's base configuration
            packVisibility: 'all'
          }
        }
      },
      phase: 'idle',           // idle | animating | gone
      vortexLevel: 0,
      packRotation: 0,
      packBlur: 0,
      packScale: 1,
      holeScale: 20,
      holeOpacity: 1,
      galaxyVisible: false,
      explodedCards: [],
      pendingPackData: null,
      _buildInterval: null,
      _suckInterval: null,

    }
  },
  computed: {
    holeStyle() {
      return {
        transform: `translate(-50%, -50%) scale(${this.holeScale})`,
        opacity: this.phase === 'idle' ? 0 : this.holeOpacity,
        transition: 'opacity 0.6s ease',
      };
    },
    packStyle() {
      return {
        transform: `translate(-50%, -50%) scale(${this.packScale}) rotate(${this.packRotation}deg)`,
        filter: `blur(${this.packBlur}px)`
      };
    }
  },
  mounted() {
    const c = this;
    c.model.currentUserId = utils.cookies.get('user_id')

     c.$root.$on('cardReveal', () => {
       c.revealPack();
     });

    c.setupSound();
    c.getPacks();
    c.getSettings();
    c.getCards();
    c.getAbilities();
    c.getBones();
    c.getAscension();
    c.getDeltaCards();

    // Initialize OBS overlay WebSocket connection
    c.connectObsWebSocket();
    // Load viewer's saved OBS preference from localStorage
    c.loadObsViewerPreference();
    // Load streamer's saved display mode preference from localStorage
    c.loadDisplayModePreference();
  },
  methods: {
    galaxy() {
      const c = this;
      c.model.canvas = document.getElementById("galaxy");
      c.model.ctx = c.model.canvas.getContext("2d");
      c.model.canvas.width = window.innerWidth;
      c.model.canvas.height = window.innerHeight;

      _galaxyStars = [];
      _vortex = 0;
      _collapse = false;
      _galaxyRunning = true;

      for (let i = 0; i < 700; i++) {
        _galaxyStars.push({
          angle:  Math.random() * Math.PI * 2,
          radius: Math.random() * 400 + 50,
          speed:  Math.random() * 0.01,
          z:      Math.random() * 2
        });
      }

      c.drawGalaxy();
    },

    drawGalaxy() {
      const c = this;
      if (!_galaxyRunning) return;

      c.model.ctx.fillStyle = "rgba(0,0,10,0.3)";
      c.model.ctx.fillRect(0, 0, c.model.canvas.width, c.model.canvas.height);

      const cx = c.model.canvas.width / 2;
      const cy = c.model.canvas.height / 2;

      // const trailLength = 0.1 + _vortex * 0.5;
      // const collapseRate = _collapse ? 0.97 - _vortex * 0.025 : 1;

      _galaxyStars.forEach(s => {
        s.angle  += s.speed + _vortex * 0.02;
        if (_collapse) s.radius *= 0.97;

        const x  = cx + Math.cos(s.angle) * s.radius;
        const y  = cy + Math.sin(s.angle) * s.radius;
        const tx = cx + Math.cos(s.angle - 0.1) * s.radius;
        const ty = cy + Math.sin(s.angle - 0.1) * s.radius;


        c.model.ctx.beginPath();
        c.model.ctx.moveTo(tx, ty);
        c.model.ctx.lineTo(x, y);
        c.model.ctx.strokeStyle = `hsla(${240 + Math.sin(s.angle) * 40},100%,${70 + _vortex * 30}%,${0.4 + _vortex * 0.4})`;
        c.model.ctx.lineWidth = s.z + _vortex * 1.5;
        c.model.ctx.stroke();

        if (s.radius < 10) s.radius = Math.random() * 400 + 200;
      });

      // ✅ Pass reference, don't invoke
      requestAnimationFrame(() => c.drawGalaxy());
    },
    revealPack(){
      const c = this;

      if (c.phase !== 'idle') return;
      c.phase = 'animating';
      c.holeScale = 15;

      c._buildInterval = setInterval(() => {
        _vortex += 0.01;
        c.vortexLevel = _vortex;
      }, 30);

      setTimeout(() => {
        _collapse = true;
        c._suckInterval = setInterval(() => {
          c.packRotation = _vortex * 720;
          c.packBlur     = _vortex * 6;
          c.packScale    = Math.max(0, 1 - _vortex);

          if (_vortex >= 1) {
            clearInterval(c._suckInterval);
            clearInterval(c._buildInterval);
            c.phase = 'gone';
            c.$nextTick(() => c.explode());
          }
        }, 16);
      }, 800);
    },

    explode() {
      const c = this;
      const cards = c.model.userCards || [];
      const count = Math.min(cards.length, 10);
      const exploded = [];

      for (let i = 0; i < count; i++) {
        const angle = (Math.PI * 2 / count) * i;
        exploded.push({
          style: {
            backgroundImage: `url(/images/cards/${cards[i].cardId}.png)`,
            transform: 'translate(-50%, -50%) scale(0.4)',
            opacity: 0
          },
          angle,
          dist: 250
        });
      }
      c.explodedCards = exploded;

      c.$nextTick(() => {
        c.processPendingPack();
        setTimeout(() => {
          c.explodedCards = c.explodedCards.map(card => {
            const dx = Math.cos(card.angle) * card.dist;
            const dy = Math.sin(card.angle) * card.dist;
            return {
              ...card,
              style: {
                ...card.style,
                opacity: 1,
                transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(1)`
              }
            };
          });
         
        }, 50);
        
        setTimeout(() => {
          c.holeOpacity = 0;
        
          setTimeout(() => {
            c.explodedCards = [];
            c.holeScale = 1;
            c.holeOpacity = 1;
            c.packScale = 1;
            c.packRotation = 0;
            c.packBlur = 0;
            _vortex = 0;
            _collapse = false;
            c.phase = 'idle';

          }, 600);
        }, 1200);
      });
    },
    shouldShowPackOpening() {
      const c = this;
      const packOpening = {
        twitchId: c.model.twitchId
      };
      return visibilityService.shouldShowPackOpening(packOpening, c.model.currentUserId);
    },
    getSettings() {
      const c = this;

      let data = {};

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;

          setTimeout(function() {
            c.getSettings();
          }, 30000);
        })
        .catch(function (error) {

        });

    },
    getCards() {
      const c = this;

      cardService.get()
        .then(function (response) {
          c.model.cards = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    setupSound() {
      const c = this;

      c.model.audio.award = new Audio('../audio/whoosh-03.mp3');

      // c.model.audio.award.addEventListener('ended', () => {
      //   c.model.audio.award.playing = 'false';
        
      // }, false);

      //Setup card flip sound and ended callback
      c.model.audio.flip = new Audio('../audio/card-flip.mp3');
      //Audio ended triggers next card flip
      c.model.audio.flip.addEventListener('ended', () => {
        c.model.audio.flip.playing = 'false';
        c.flipCards();
      }, false);
      
    },
    getPacks() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getAbilities() {
      const c = this;

      let data = {};

      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.abilities = data;
          c.getUnlocks();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getBones() {
      const c = this;

      let data = {};

      boneCardService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.boneCards = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getAscension() {
      const c = this;

      let data = {};

      boneCardService.getAscension()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.ascensionCard = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getDeltaCards() {
      const c = this;

      let data = {};

      deltaCardService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.deltaCards = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getUnlocks() {
      const c = this;

      //Prevent calling api while a pack is loaded
      if (c.model.packLoaded) {
        return;
      }

      if (c.model.settings.autoopen && c.model.settings.autoopen.value) {

        //Spreads out the open packs to every 6 seconds
        setTimeout(function() {

          unlockQueueService.getAuto()
            .then(function (response) {
              c.galaxyVisible = true;
              c.galaxy();
              c.processPackOpen(response.data[0]);
            })
            .catch(function (error) {
              setTimeout(function() {
                c.getUnlocks();
              }, _UNLOCKCHECK);
            });

        }, 3000);

      } else {

        unlockQueueService.getActive()
          .then(function (response) {
            c.galaxyVisible = true;
            c.galaxy();
            c.processPackOpen(response.data[0]);
          })
          .catch(function (error) {
            setTimeout(function() {
              c.getUnlocks();
            }, _UNLOCKCHECK);
          });

      }
    },
    processPackOpen(data) {
      const c = this;

      let id = data.id;

      if (id != c.model.id) {

        c.model.id = id;
        c.model.twitchId = data.twitchId;
        c.model.twitchDisplayName = data.twitchDisplayName;
        c.model.pack = c.model.packs[data.packId];
        c.model.pendingPackData = data;
        c.model.packLoaded = true;

        // Wait for user to click the pack cover (cardReveal) before processing

      } else {
        setTimeout(function() {
          c.getUnlocks();
        }, _UNLOCKCHECK);
      }
    },

    processPendingPack() {
      const c = this;
      const data = c.model.pendingPackData;
      if (!data) return;

      c.saveCards(data, function(deltaDrops) {

        c.getUserCards(function() {
          if (deltaDrops && deltaDrops.length > 0) {
            c.model.userCards = (c.model.userCards || []).concat(deltaDrops);
          }
          c.checkFrameDrops(data.packId, data.twitchId);

          setTimeout(function() {

            if (c.model.twitchDisplayName == null) {
              c.getTwitchName();
            } else {
              c.open();
              c.save();
            }

          }, 1500);
        });

      });
    },
    saveCards(data, callback, retryCount = 0) {
      const c = this;

      const maxRetries = 10;
      let pack = c.model.packs[data.packId];
      let packSize = Number(pack.size);
      let saved = 0;

      console.log(pack);
      console.log(c.model.cards);
      let cards = playingCards.openPack(pack, c.model.cards, c.model.boneCards, c.model.ascensionCard, c.model.deltaCards);

      const hasUndefined = cards.some(card => card == null || card == undefined || card.id == null || card.id == undefined);
      const correctLength = cards.length === packSize;

      console.log(cards);

      if (hasUndefined || !correctLength) {
        if (retryCount < maxRetries) {
          c.saveCards(data, callback, retryCount + 1);
        } else {
          setTimeout(function() {
            c.saveCards(data, callback);
          }, 3000);
        }
        return;
      }

      const deltaDrops = cards.filter(card => card.deltaCard);

      for (let i = 0; i < cards.length; i++) {

        userService.saveCards({twitchId: data.twitchId, unlockQueueId: data.id, cardId: cards[i].id, tier: cards[i].tier, value: cards[i].value, deltaCard: cards[i].deltaCard || false})
          .then(function (response) {
            saved += 1;

            if (saved == packSize) {
              callback(deltaDrops);
            }
          })
          .catch(function (error) {
            //console.log(error);
          });

      }

    },
    getUserCards(callback) {
      const c = this;
      let cards = [];
      
      userService.getCards({twitchId: c.model.twitchId, id: c.model.id})
        .then(function (response) {
          
          for (let card of response.data) {
            cards.push(card);
          }
          
          c.model.userCards = playingCards.getCardsStats(cards, c.model.abilities);
          
          callback();
        })
        .catch(function (error) {
          c.model.userCards = c.model.userCards || [];
          callback();
        });
    },
    getTwitchName() {
      const c = this;
      let url = `${apiUrl}users?id=${c.model.twitchId}`;
      
      //TODO refactor into univarsal function
      axios.get(url, {
          headers: { 
            'Client-ID': clientId,
            'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
          }
        })
        .then(function (response) {
          for (let d of response.data.data) {
            c.model.twitchDisplayName = d.display_name ? d.display_name : null;
          }
          c.open();
          c.save();
        })
        .catch(function (error) {
          //Just in case it couldn't load the user name from the API
          c.open();
          c.save();
        });
    },
    scroll() {
      const c = this;

      const cardsContainer = document.getElementById('opened-cards');
      cardsContainer.scrollLeft = 0;

      clearInterval(c.model.scrollInterval);
      c.model.scrollInterval = null; 

      let checkDone = 0;
      let lastScrollLeft = 0;
      cardsContainer.scrollLeft = 0;
      
      let mouseDown = false;

      document.body.onmousedown = function() { 
        mouseDown = true;
      }

      document.body.onmouseup = function() {
        mouseDown = false;
      }

      if (!c.model.scrollInterval) {
        cardsContainer.scrollLeft = 0;
      }

      c.model.scrollInterval = setInterval(() => {
        lastScrollLeft = cardsContainer.scrollLeft;
        
        if (checkDone < 333 && !mouseDown) {
          cardsContainer.scrollTo(cardsContainer.scrollLeft + 1, 0);
        } else if (checkDone >= 333) {

          clearInterval(c.model.scrollInterval);
          c.model.scrollInterval = null;
          console.log('🎬 Scroll complete, scheduling reset in 8 seconds...');
          setTimeout(function() {
            c.reset();


            //c.getUnlocks();
          }, 8000);
        }

        if (cardsContainer.scrollLeft == lastScrollLeft) {
          checkDone += 1;
        }
      }, 15);

    },
    reset() {
      const c = this;

      console.log('✅ reset() function called - starting cleanup');

      // Broadcast reset event via WebSocket to notify extension
      console.log('📡 Broadcasting packReset event via WebSocket...');
      c.broadcastReset();

      // Reload page after a short delay to ensure broadcast is sent
      setTimeout(() => {
        console.log('🔄 Reloading page...');
        window.location.reload();
      }, 500);
    },
    broadcastReset() {
      console.log('[broadcastReset] Starting WebSocket connection...');
      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          console.log('[broadcastReset] WebSocket connected!');
          // Get streamer's channel ID
          const streamerChannelId = utils.cookies.get('channelId');

          const message = {
            message: 'packReset',
            channelId: streamerChannelId,
            timestamp: new Date().toLocaleString()
          };

          console.group('🔄 PACK RESET EVENT - BROADCAST');
          console.log('Streamer Channel ID:', streamerChannelId);
          console.log('Reset Message:', message);
          console.groupEnd();

          const jsonMessage = JSON.stringify(message);
          console.log('[broadcastReset] Sending message:', jsonMessage);
          ws.send(jsonMessage);
          ws.close();
        };

        ws.onerror = (error) => {
          console.warn('⚠️ WebSocket reset broadcast failed:', error);
        };

        ws.onclose = () => {
          console.log('✅ Pack reset message sent via WebSocket');
        };
      } catch (error) {
        console.warn('⚠️ WebSocket unavailable for reset broadcast:', error);
      }
    },
    save() {
      const c = this;

      unlockQueueService.save({id: c.model.id, open: true})
      .then(function (response) {
        // Broadcast pack opened event via WebSocket for real-time OBS overlay updates
        c.broadcastPackOpened();
      })
      .catch(function (error) {
        //console.log(error);
      });
    },
    broadcastPackOpened() {
      const c = this;

      try {
        const ws = new WebSocket(utils.getWsUrl());

        ws.onopen = () => {
          // Get streamer's channel ID (for WebSocket routing to correct extension viewer)
          const streamerChannelId = utils.cookies.get('channelId') || c.model.twitchId;

          const message = {
            message: 'packOpened',
            channelId: streamerChannelId,  // Streamer's channel ID (for extension routing)
            packId: c.model.id,  // Unlock queue ID for matching
            userName: c.model.twitchDisplayName,
            packType: c.model.pack ? c.model.pack.name : 'unknown',
            cardCount: c.model.userCards ? c.model.userCards.length : 0,
            timestamp: new Date().toLocaleString(),
            twitchId: c.model.twitchId,  // Pack owner's Twitch ID for visibility filtering
            cards: c.model.userCards || [],  // Full card objects with stats
            frameDrops: c.model.frameDrops || [],  // Bonus frame rewards
            backgroundDrops: c.model.backgroundDrops || []  // Bonus background rewards
          };

          // DEBUG: Log pack opening event
          console.group('🎉 PACK OPENED EVENT - BROADCAST');
          console.log('Streamer Channel ID (for routing):', streamerChannelId);
          console.log('Pack Owner Twitch ID:', c.model.twitchId);
          console.log('Pack Owner Display Name:', c.model.twitchDisplayName);
          console.log('Pack Type:', c.model.pack ? c.model.pack.name : 'unknown');
          console.log('Card Count:', c.model.userCards ? c.model.userCards.length : 0);
          console.log('Cards:', c.model.userCards);
          console.log('Full Message:', message);
          console.groupEnd();

          const jsonMessage = JSON.stringify(message);
          console.log('[broadcastPackOpened] JSON message to be sent:', jsonMessage);
          console.log('[broadcastPackOpened] Message size:', jsonMessage.length, 'bytes');

          ws.send(jsonMessage);
          ws.close();
        };

        ws.onerror = (error) => {
          // WebSocket broadcast failed - not critical, OBS will update via polling
          console.warn('⚠️ WebSocket broadcast failed:', error);
        };

        ws.onclose = () => {
          // Connection closed
          console.log('✅ Pack broadcast message sent via WebSocket');
        };
      } catch (error) {
        // WebSocket unavailable - graceful degradation
        console.warn('⚠️ WebSocket unavailable for pack broadcast:', error);
      }
    },
    open() {
      const c = this;

      c.packScale = 1;
      c.packRotation = 0;
      c.packBlur = 0;

      let $card = $('.cover');

      $card.removeClass('pulse');
      $card.addClass('shrink');

      c.model.audio.award.play();

      setTimeout(function() {
        $card.addClass('fade-out');
      }, 600);

      setTimeout(function() {
        $card.addClass('hide');
      }, 1000);

      setTimeout(function() {
        //utils.explosion();
      }, 1300);

      setTimeout(function() {
        $('.opened-cards').toggleClass('opened').addClass(`cards-${c.model.userCards.length}`);

        setTimeout(function() {
          $('.open-pack-container').removeClass('collapsed').addClass('show');
          $('.open-pack-container h2').addClass('show');

          setTimeout(function() {
            setTimeout(function() {
              //c.explosions();
              c.flipCards();
              setTimeout(function() {
                c.scroll();
              }, 1000); 
            }, 500);
          }, 1000);
        }, 500); 
      }, 500);
    },
    explosions() {
      utils.explosion();

      setTimeout(function() {
        utils.explosion();
      }, 1400);

      setTimeout(function() {
        utils.explosion();
      }, 2800);
    },
    flipCards() {
      let c = this;
      let count = $('.opened-cards .playing-card').length;

      if (c.model.index == count) {
        c.model.index = 0;
        return;
      }

      c.model.index += 1;

      //let $card = $('.opened-cards .playing-card')[c.model.index];
      $('.info').removeClass('is-visible');
      $('.bottom').removeClass('is-hidden');
      $(`.playing-card-container:nth-of-type(${c.model.index}) .playing-card`).trigger('click');
      //$card.trigger('click');

      c.model.audio.flip.load();
      c.model.audio.flip.play();

      //$('.opened-cards .playing-card').each(function(index) {
        // $('.info').removeClass('is-visible');
        // $('.bottom').removeClass('is-hidden');
        // $card.trigger('click');
        
      //});

    },
    // Check for frame and background drops from chests/packs
    checkFrameDrops(packId, twitchId) {
      const c = this;

      if (!packId || !twitchId) return;

      const chestType = c.model.pack ? c.model.pack.id : packId;

      // Get frame chest rewards
      rewardFrameService.getChestRewards(twitchId)
        .then(function(response) {
          if (response.success && response.data) {
            // Filter for rewards matching this chest/pack type
            const potentialDrops = response.data.filter(r =>
              r.chest_type === chestType &&
              !r.is_claimed &&
              r.is_active
            );

            // Process drop rates
            c.processFrameDrops(potentialDrops, packId, twitchId);
          }
        })
        .catch(function(error) {
          console.error('Error loading frame chest rewards:', error);
        });

      // Get background chest rewards
      rewardBackgroundService.getChestRewards(twitchId)
        .then(function(response) {
          if (response.success && response.data) {
            // Filter for rewards matching this chest/pack type
            const potentialDrops = response.data.filter(r =>
              r.chest_type === chestType &&
              !r.is_claimed &&
              r.is_active
            );

            // Process drop rates
            c.processBackgroundDrops(potentialDrops, packId, twitchId);
          }
        })
        .catch(function(error) {
          console.error('Error loading background chest rewards:', error);
        });
    },
    processFrameDrops(frameRewards, chestId, twitchId) {
      const c = this;

      if (!frameRewards || frameRewards.length === 0) return;

      frameRewards.forEach(reward => {
        // Determine if frame drops
        let drops = false;

        if (reward.is_guaranteed) {
          drops = true;
        } else if (reward.drop_rate) {
          const roll = Math.random() * 100;
          drops = roll <= parseFloat(reward.drop_rate);
        }

        // If frame drops, claim it
        if (drops) {
          rewardFrameService.claimChestReward(reward.id, chestId)
            .then(function(response) {
              if (response.success) {
                c.model.frameDrops.push({
                  id: reward.frame_id,
                  name: reward.frame_name || reward.reward_name,
                  description: reward.frame_description || reward.description,
                  unlock_type: reward.unlock_type,
                  image_url: reward.frame_image_url,
                  type: 'frame'
                });

                utils.alert.success(`Frame dropped: ${reward.frame_name || reward.reward_name}!`);
              }
            })
            .catch(function(error) {
              console.error('Error claiming frame drop:', error);
            });
        }
      });
    },
    processBackgroundDrops(backgroundRewards, chestId, twitchId) {
      const c = this;

      if (!backgroundRewards || backgroundRewards.length === 0) return;

      backgroundRewards.forEach(reward => {
        // Determine if background drops
        let drops = false;

        if (reward.is_guaranteed) {
          drops = true;
        } else if (reward.drop_rate) {
          const roll = Math.random() * 100;
          drops = roll <= parseFloat(reward.drop_rate);
        }

        // If background drops, claim it
        if (drops) {
          rewardBackgroundService.claimChestReward(reward.id, chestId)
            .then(function(response) {
              if (response.success) {
                c.model.backgroundDrops.push({
                  id: reward.background_id,
                  name: reward.background_name || reward.reward_name,
                  description: reward.background_description || reward.description,
                  unlock_type: 'background',
                  image_url: reward.background_image_url,
                  type: 'background'
                });

                utils.alert.success(`Background dropped: ${reward.background_name || reward.reward_name}!`);
              }
            })
            .catch(function(error) {
              console.error('Error claiming background drop:', error);
            });
        }
      });
    },
    // Load viewer's OBS preference from localStorage
    loadObsViewerPreference() {
      const c = this;
      const saved = localStorage.getItem('obsViewerPreference');
      c.model.obsOverlay.viewerPreference = saved || 'all';
      console.log('[openPack OBS] Loaded viewer preference:', c.model.obsOverlay.viewerPreference);
    },

    // Save viewer's OBS preference to localStorage
    saveObsViewerPreference(preference) {
      const c = this;
      if (!['all', 'mine', 'others'].includes(preference)) {
        console.warn('[openPack OBS] Invalid preference:', preference);
        return;
      }
      localStorage.setItem('obsViewerPreference', preference);
      c.model.obsOverlay.viewerPreference = preference;
      console.log('[openPack OBS] Saved viewer preference:', preference);
      c.applyObsFilters();
    },

    // Apply viewer preference filter (single-layer filtering)
    applyObsFilters() {
      const c = this;
      const viewerPreference = c.model.obsOverlay.viewerPreference;
      const currentUserId = c.model.currentUserId;

      // Get raw data
      const rawPacks = c.model.obsOverlay.allPacks;

      // Apply only viewer's preference filter
      let filteredPacks = c.filterByViewerPreference(rawPacks, viewerPreference, currentUserId, 'packs');

      // Update display
      c.model.obsOverlay.recentPacks = filteredPacks;

      console.log('[openPack OBS] Applied viewer preference filter - Packs:', filteredPacks.length);
    },

    // Filter by viewer's preference (single-layer filtering)
    filterByViewerPreference(items, preference, currentUserId, itemType) {
      if (preference === 'mine' && currentUserId) {
        // Show only packs opened for this specific viewer (where they were involved)
        if (itemType === 'packs') {
          return items.filter(item => item.twitchId === currentUserId);
        }
      } else if (preference === 'others' && currentUserId) {
        // Show only packs opened for other viewers (NOT this viewer)
        if (itemType === 'packs') {
          return items.filter(item => item.twitchId !== currentUserId);
        }
      }
      return items; // Return all if 'all'
    },

    // OBS Overlay WebSocket Connection
    connectObsWebSocket() {
      const c = this;
      try {
        c.obsWs = new WebSocket(utils.getWsUrl());

        c.obsWs.onopen = () => {
          console.log('[openPack OBS] WebSocket connected');
          c.model.obsOverlay.connected = true;
        };

        c.obsWs.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);

            // Handle streamer OBS settings changes (NEW)
            if (data.message === 'obsSettingsChanged') {
              console.log('[openPack OBS] Streamer OBS settings changed');
              // Reload streamer configuration and re-apply filters
              c.fetchObsStreamerSettings();
            }

            // Handle new pack opened events
            if (data.message === 'packOpened') {
              console.log('[openPack OBS] New pack opened event received');
              c.applyObsFilters(); // Use existing filters
            }
          } catch (e) {
            console.error('[openPack OBS] Error parsing WebSocket message:', e);
          }
        };

        c.obsWs.onerror = (error) => {
          console.log('[openPack OBS] WebSocket error:', error);
          c.model.obsOverlay.connected = false;
        };

        c.obsWs.onclose = () => {
          console.log('[openPack OBS] WebSocket disconnected, attempting reconnect...');
          c.model.obsOverlay.connected = false;
          setTimeout(() => c.connectObsWebSocket(), 3000);
        };
      } catch (error) {
        console.log('[openPack OBS] WebSocket connection failed:', error);
        c.model.obsOverlay.connected = false;
      }
    },
    // Fetch streamer's OBS settings
    fetchObsStreamerSettings() {
      const c = this;
      const channelId = utils.cookies.get('channelId');

      if (!channelId) {
        console.log('[openPack OBS] No channel ID available for streamer settings');
        return;
      }

      fetch(`/application/api/obs/streamer-settings.php?channelId=${channelId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if (data.success) {
            c.model.obsOverlay.streamerConfig = {
              packVisibility: data.data.packVisibility || 'all'
            };
            console.log('[openPack OBS] Loaded streamer config:', c.model.obsOverlay.streamerConfig);
            // Re-apply filters with new streamer config
            c.applyObsFilters();
          } else {
            console.log('[openPack OBS] Failed to load streamer settings:', data.error);
          }
        })
        .catch(error => {
          console.error('[openPack OBS] Fetch streamer settings error:', error);
        });
    },

    fetchRecentPacks() {
      const c = this;
      // For OBS overlay, we show recently opened packs
      // Track the currently opening pack in a simple way
      // This is populated when processPackOpen() is called
      if (c.model.id && c.model.twitchId) {
        c.model.obsOverlay.allPacks = [{
          id: c.model.id,
          twitchId: c.model.twitchId,
          twitchDisplayName: c.model.twitchDisplayName,
          packId: c.model.pack?.id,
          packName: c.model.pack?.name
        }];
        console.log('[openPack OBS] Loaded current pack for overlay:', {
          twitchId: c.model.twitchId,
          packId: c.model.pack?.id
        });
      } else {
        c.model.obsOverlay.allPacks = [];
        console.log('[openPack OBS] No current pack to display');
      }
      // Apply filters to get display data
      c.applyObsFilters();
    },
    toggleObsOverlay() {
      const c = this;
      c.model.obsOverlay.visible = !c.model.obsOverlay.visible;
      c.model.obsOverlay.toggleState = c.model.obsOverlay.visible ? 'on' : 'off';

      console.log('[openPack OBS] Toggle state:', c.model.obsOverlay.toggleState);
      console.log('[openPack OBS] Overlay visible:', c.model.obsOverlay.visible);
      console.log('[openPack OBS] Complete state:', c.model.obsOverlay);

      if (c.model.obsOverlay.visible && c.model.obsOverlay.recentPacks.length === 0) {
        c.fetchRecentPacks();
      }
    },

    /**
     * Load streamer's display mode preference from backend or localStorage
     */
    loadDisplayModePreference() {
      const c = this;
      const channelId = utils.cookies.get('channelId');

      if (!channelId) {
        // Fallback to localStorage if no channel ID
        const saved = localStorage.getItem('obsDisplayMode');
        c.model.obsOverlay.displayMode = (saved && streamerDisplayModeService.isValidMode(saved)) ? saved : 'broadcast';
        console.log('[openPack OBS] No channel ID, using localStorage fallback:', c.model.obsOverlay.displayMode);
        return;
      }

      // Load from backend API using service
      streamerDisplayModeService.get(channelId)
        .then(response => {
          if (response.data.success && response.data.data) {
            c.model.obsOverlay.displayMode = response.data.data.displayMode || 'broadcast';
            console.log('[openPack OBS] Loaded display mode from backend:', c.model.obsOverlay.displayMode);
          } else {
            throw new Error(response.data.message || 'Unknown error');
          }
        })
        .catch(error => {
          console.error('[openPack OBS] Error loading from backend:', error);
          // Fallback to localStorage
          const saved = localStorage.getItem('obsDisplayMode');
          c.model.obsOverlay.displayMode = (saved && streamerDisplayModeService.isValidMode(saved)) ? saved : 'broadcast';
          console.log('[openPack OBS] Falling back to localStorage:', c.model.obsOverlay.displayMode);
        });
    },

    /**
     * Toggle display mode between broadcast (show on OBS) and extension only
     */
    toggleDisplayMode() {
      const c = this;

      // Toggle the mode
      c.model.obsOverlay.displayMode = c.model.obsOverlay.displayMode === 'broadcast' ? 'extension' : 'broadcast';

      console.log('[openPack OBS] Display mode toggled to:', c.model.obsOverlay.displayMode);
      console.log('[openPack OBS] Current state:', {
        displayMode: c.model.obsOverlay.displayMode,
        visible: c.model.obsOverlay.visible,
        toggleState: c.model.obsOverlay.toggleState
      });

      // Save preference to localStorage for persistence
      c.saveDisplayModePreference(c.model.obsOverlay.displayMode);
    },

    /**
     * Save display mode preference to localStorage and backend
     */
    saveDisplayModePreference(displayMode) {
      if (!['broadcast', 'extension'].includes(displayMode)) {
        console.error('[openPack OBS] Invalid display mode:', displayMode);
        return;
      }

      // Save to localStorage for immediate persistence
      localStorage.setItem('obsDisplayMode', displayMode);
      console.log('[openPack OBS] Display mode saved to localStorage:', displayMode);

      // Save to backend API if channel ID is available
      const channelId = utils.cookies.get('channelId');
      if (channelId) {
        fetch('/api/obs/display-mode.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            displayMode: displayMode,
            channelId: channelId
          })
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`API Error: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            if (data.success) {
              console.log('[openPack OBS] Display mode saved to backend:', displayMode);
            } else {
              throw new Error(data.message || 'Unknown error');
            }
          })
          .catch(error => {
            console.error('[openPack OBS] Warning: Failed to save to backend:', error);
            console.log('[openPack OBS] Preference is saved locally (localStorage) but not persisted to database');
          });
      } else {
        console.warn('[openPack OBS] No channel ID available - preference only saved to localStorage');
      }
    },

    setObsOverlayMode(mode) {
      const c = this;
      c.model.obsOverlay.mode = mode; // 'modal', 'side', 'bottom'
    }
  }
});